import axios from 'axios'
import { apiBaseUrl } from './config'
import { isStoredSessionStarted, getStoredSession, rawLogout, refreshToken } from '@/lib/session'
import { redirect } from '@/lib/location'

const instanceUpload = axios.create({
  baseURL: apiBaseUrl(),
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

function succesInterceptor (config) {
  let authHeaders = {}
  if (isStoredSessionStarted()) {
    const { token, sessionId } = getStoredSession()
    authHeaders = {
      'Authorization': `Bearer ${token}`,
      'api-session-id': sessionId
    }
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      ...authHeaders
    }
  }
}

function successResponse (response) {
  if (response.data && response.data.refreshToken) {
    refreshToken(response.data.refreshToken)
  }
  return response
}

function errorInterceptor (error) {
  // Erro de conexao seja pelo servidor estar
  // off ou o front nao estar conectado a internet
  if (error.message.match(/Network Error/)) {
    return Promise.reject(new Error('Não foi possível conectar com o servidor!'))
  }

  if (error.response.status === 401) {
    isStoredSessionStarted() && rawLogout()
  }

  // Erros 403 utilizando timeout
  // para ser executado apos o retorno
  // da promise, permitindo o component
  // vue exibir um modal com a mensagem
  // de erro de sessao por exemplo.
  if (error.response.status === 403) {
    setTimeout(() => redirect('main'), 3560)
  }

  if (error.response && error.response.data) {
    return Promise.reject(new Error(error.response.data.message))
  }

  // retorno sem mensagem de erro
  return Promise.reject(new Error('Ocorreu um erro inesperado!'))
}

instanceUpload.interceptors.request.use(succesInterceptor, undefined)
instanceUpload.interceptors.response.use(successResponse, errorInterceptor)

/**
 * @param {Object} options
 * @param {String} options.method
 * @param {String} options.url
 * @param {Object} options.data Dados enviados em requisicoes 'PUT', 'POST', e 'PATCH'
 * @returns {Promise}
 */
export async function requestUpload (options) {
  const { data: response } = await instanceUpload.request({
    url: options.url,
    method: options.method.toLowerCase(),
    data: options.data,
    params: options.params
  })
  return response.data
}

export default instanceUpload
